import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15d38d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row col-12"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "Spare parts", -1 /* HOISTED */))
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "q-pa-md" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_AddSparePartDialog = _resolveComponent("AddSparePartDialog")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "q-mb-lg col-12" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row justify-between card-title flex-center" }, {
              default: _withCtx(() => [
                _hoisted_2,
                (!_ctx.isUserUnknownOrGuest())
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      class: "main-button",
                      label: "New spare parts",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayAddSparePartDialog(true)))
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_table, {
                  rows: _ctx.getEquipmentDetails?.spareParts,
                  "hide-pagination": true,
                  columns: _ctx.columnsSpareParts,
                  filter: _ctx.filter,
                  pagination: { rowsPerPage: 0 }
                }, {
                  body: _withCtx((props) => [
                    _createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, {
                          key: "materialNumber",
                          style: {"width":"15%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.materialNumber), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_q_td, {
                          key: "materialName",
                          style: {"width":"35%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.materialName), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_q_td, {
                          key: "plant",
                          style: {"width":"5%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.plant), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_q_td, {
                          key: "status",
                          style: {"width":"12%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.currentStock) + " ", 1 /* TEXT */),
                            (props.row.status)
                              ? (_openBlock(), _createBlock(_component_q_chip, {
                                  key: 0,
                                  modelValue: props.row.status,
                                  "onUpdate:modelValue": ($event: any) => ((props.row.status) = $event),
                                  square: "",
                                  icon: _ctx.icon(props.row.status),
                                  class: _normalizeClass([_ctx.getClassSparePartIcon(props.row.status), "text-uppercase"]),
                                  label: _ctx.getSparePartsLabelForChip(props.row.status),
                                  "text-color": "white"
                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "icon", "class", "label"]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_q_td, {
                          key: "linkToSceff",
                          style: {"width":"15%"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "main-link",
                              target: "_blank",
                              href: `https://azrpscefappgwst.scef.iasp.tgscloud.net/details-for-material/${props.row.materialNumber}?country=${_ctx.getSelectedCountryBlocInShort}`
                            }, " Go to SCEF ", 8 /* PROPS */, _hoisted_5)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_q_td, {
                          key: "delete",
                          style: {"width":"5%"}
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.isUserUnknownOrGuest())
                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 0,
                                  name: "delete",
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (_ctx.openConfirmDeleteSparePart(props.row))
                                }, null, 8 /* PROPS */, ["onClick"]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"])
                  ]),
                  "top-left": _withCtx(() => [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.filter,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
                      dense: "",
                      outlined: "",
                      debounce: "300",
                      placeholder: "Keyword Search"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "search" })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["rows", "columns", "filter"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_ConfirmDialog, {
          title: "Delete spare part",
          message: _ctx.confirmDeleteSparePartMessage,
          open: _ctx.displayConfirmDeleteSparePartDialog,
          onOnClose: _ctx.closeConfirmDeleteSparePart,
          onOnConfirm: _ctx.onConfirmDeleteSparePart
        }, null, 8 /* PROPS */, ["message", "open", "onOnClose", "onOnConfirm"]),
        _createVNode(_component_AddSparePartDialog)
      ]))
    : _createCommentVNode("v-if", true)
}